import { executionRunFragment } from './fragments';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const automationTestAtom = createMutationAtomFactory(
  'automations.test',
  (params: { id: string; testPayload?: Record<string, unknown> }) => ({
    automationsAutomationTest: {
      __args: {
        id: params.id,
        testPayload: params.testPayload,
      },
      ...executionRunFragment,
    },
  }),
  { showLoadingOverlay: false },
);
